import { InternalMailPlatform } from "@/features/internal-mail-platform";
import { createFileRoute } from "@tanstack/react-router";
import { useFlag } from "@unleash/proxy-client-react";
import Page404 from "./-components/-page404";

export const Route = createFileRoute("/_auth/internal/send-user-emails")({
  component: SendUserEmails
});

function SendUserEmails() {
  const isNumerousEmployee = useFlag("is-numerous-employee");

  if (!isNumerousEmployee) return <Page404 />;

  return <InternalMailPlatform />;
}
